<template>
  <div class="wrapper">
    <el-row :gutter="20">
      <el-col :span="6" :xs="12">
        <div class="card" @click="skipAccessControlStatus('1')">
          <img class="img" src="../../assets/微信图片_20200402154627.png" />
          <div class="card-content">
            <div>在线 / 门禁总数</div>
            <div>
              {{ stat.onLineNum }}<span>/{{ stat.total }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6" :xs="12">
        <div class="card" @click="skipAccessControlStatus('0')">
          <img class="img" src="../../assets/微信图片_20200402154621.png" />
          <div class="card-content">
            <div>离线 / 门禁总数</div>
            <div>
              {{ stat.offLineNum }}<span>/{{ stat.total }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6" :xs="12">
        <div
          class="card"
          @click="$router.push(`/GarageManage/AccessControlDevice?tab=unBind`)"
        >
          <img class="img" src="../../assets/9.png" />
          <div class="card-content">
            <div>未绑定 / 门禁总数</div>
            <div>
              {{ stat.unBindNum }}<span>/{{ stat.total }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="5" class="m-mp-10">
      <el-form ref="params" :model="params">
        <el-col :span="4" :xs="12">
          <el-form-item prop="id">
            <el-input v-model="params.id" placeholder="车库ID" maxlength="11" />
          </el-form-item>
        </el-col>
        <el-col :span="4" :xs="12">
          <el-form-item prop="name">
            <el-input
              v-model="params.name"
              placeholder="车库名称"
              maxlength="20"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4" :xs="12">
          <el-form-item prop="mobile">
            <el-input v-model="params.mobile" placeholder="手机号码" />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>

    <el-row style="margin-bottom: 10px" class="xs-mp-10">
      <el-col :span="3" :xs="12">
        <el-button
          type="primary"
          @click="(createAndEditCarportDialog = true), (type = 0)"
          >创建车库</el-button
        >
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="6" :xs="24" v-for="item in records" :key="item.id">
        <lp-list-item :item="item" :rows="dataRows">
          <template #option="scope">
            <div v-if="scope.row" style="margin: 0 10px 8px 0">
              <el-button size="mini" @click="edit(scope.row.id)"
                >修改车库
              </el-button>
            </div>
            <div v-if="scope.row" style="margin: 0 10px 8px 0">
              <el-button size="mini" type="primary" @click="openDoor(scope.row)"
                >远程开门
              </el-button>
            </div>
          </template>
        </lp-list-item>
      </el-col>
    </el-row>

    <!-- <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
    >
      <el-table-column label="车库ID" prop="id" width="130">
        <template #default="scope">
          <span class="click" @click="skipAccessControlDevice(scope.row)">
            {{ scope.row.id }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="车库名称" prop="name">
        <template #default="scope">
          <span class="click" @click="skipAccessControlDevice(scope.row)">{{
            scope.row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="门禁总数" prop="accessControlDeviceSize">
        <template #default="scope">
          {{ scope.row.accessControlDeviceSize || 0 }}
        </template>
      </el-table-column>
      <el-table-column label="在线门禁" prop="onLineAccessControlDeviceSize">
        <template #default="scope">
          <span class="click" @click="skipAccessControlDevice(scope.row, '1')">
            {{ scope.row.onLineAccessControlDeviceSize || 0 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="离线门禁" prop="offLineAccessControlDeviceSize">
        <template #default="scope">
          <span class="click" @click="skipAccessControlDevice(scope.row, '0')">
            {{ scope.row.offLineAccessControlDeviceSize || 0 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="deviceGroup.mobile" />
      <el-table-column label="创建时间" prop="creatTime" width="250">
        <template #default="scope">
          {{ timeFormat(scope.row.creatTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280">
        <template #default="scope">
          <el-button size="mini" @click="edit(scope.row.id)"
            >修改车库
          </el-button>
          <el-button size="mini" type="primary" @click="openDoor(scope.row)"
            >远程开门
          </el-button>
        </template>
      </el-table-column>
    </el-table> -->

    <page :current="current" :size="size" :total="total" />
    <create-and-edit-carport-dialog
      :dialog="createAndEditCarportDialog"
      :id="id"
      :type="type"
    />
    <open-door-dialog
      :dialog="openDoorDialog"
      :openDoorDialogObj="openDoorDialogObj"
      @close="openDoorDialogObj = {}"
    />
  </div>
</template>

<script>
import agentGetAccessControlDeviceNumDateil from "@/api/device/access-control-device-controler/agentGetAccessControlDeviceNumDateil";
import agentGetCarportByPage from "@/api/device/carport-controler/agentGetCarportByPage";
import Page from "@/components/Page";
import createdMixin from "@/mixin/createdMixin";
import dialogMixin from "@/mixin/dialogMixin";
import formatPhone from "@/mixin/formatPhoneMixin";
import pageMixin from "@/mixin/pageMixin";
import resDispose from "@/mixin/resDisposeMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";
import CreateAndEditCarportDialog from "@/views/GarageManage/dialog/createAndEditCarportDialog";
import openDoorDialog from "@/views/GarageManage/dialog/openDoorDialog";
import agentDelCarport from "../../api/device/carport-controler/agentDelCarport";

import LpListItem from "@/components/LpListItem.vue";

export default {
  name: "GarageManage",
  components: { CreateAndEditCarportDialog, Page, openDoorDialog, LpListItem },
  mixins: [
    pageMixin,
    dialogMixin,
    createdMixin,
    timeMixin,
    resDispose,
    searchMixin,
  ],
  data() {
    return {
      type: undefined,
      id: undefined,
      createAndEditCarportDialog: false,
      records: [],
      params: {
        pageNum: 1,
        size: 10,
        sortName: "id",
        sortType: "DESC",
        id: undefined,
        name: undefined,
        mobile: undefined,
      },
      loadTable: true,
      stat: {
        total: 0,
        onLineNum: 0,
        offLineNum: 0,
        unBindNum: 0,
      },
      openDoorDialog: false,
      openDoorDialogObj: {},
      dataRows: [
        {
          label: "车库ID",
          prop: "id",
          click: (row) => {
            this.skipAccessControlDevice(row);
          },
        },
        {
          label: "车库名称",
          prop: "name",
          click: (row) => {
            this.skipAccessControlDevice(row);
          },
        },
        {
          label: "门禁总数",
          prop: "accessControlDeviceSize",
          format: (v) => v || 0,
        },
        {
          label: "在线门禁",
          prop: "onLineAccessControlDeviceSize",
          format: (v) => v || 0,
          click: (row) => {
            this.skipAccessControlDevice(row, "1");
          },
        },
        {
          label: "离线门禁",
          prop: "offLineAccessControlDeviceSize",
          format: (v) => v || 0,
          click: (row) => {
            this.skipAccessControlDevice(row, "0");
          },
        },
        { label: "手机号", prop: "deviceGroup.mobile" },
        {
          label: "创建时间",
          prop: "creatTime",
          format: (v) => this.timeFormat(v),
        },
      ],
    };
  },
  created() {
    this.fetchGetAccessControlDeviceNumDateil();
  },
  mounted() {
    this.refresh.$on("creatCarportSuccess", () => {
      this.fetchData();
      this.createAndEditCarportDialog = false;
    });
  },
  watch: {
    "params.mobile": {
      handler() {
        this.params.mobile = formatPhone(this.params.mobile);
      },
    },
    "params.name": {
      handler(newV) {
        if (!newV) return;
        this.params.name = newV.trim();
      },
    },
  },
  methods: {
    fetchGetAccessControlDeviceNumDateil() {
      agentGetAccessControlDeviceNumDateil().then((res) => {
        this.stat = res.data;
      });
    },
    skipAccessControlDevice(row, status) {
      const query = { carportId: row.id };
      if (status !== undefined) {
        query.status = status;
      }
      this.$router.push({ path: "/GarageManage/AccessControlDevice", query });
    },
    skipAccessControlStatus(status) {
      const query = {};
      if (status !== undefined) {
        query.status = status;
      }
      this.$router.push({ path: "/GarageManage/AccessControlDevice", query });
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }
      // console.log(this.params.sortName)
      // console.log(this.params.sortType)
      this.fetchData();
    },
    edit(id) {
      this.type = 1;
      this.id = id;
      this.createAndEditCarportDialog = true;
    },
    openDoor(row) {
      this.openDoorDialogObj = row;
      this.openDoorDialog = true;
    },
    generateQrcode() {},
    create() {
      this.type = 0;
      this.createAndEditCarportDialog = true;
    },
    del(id) {
      this.$confirm("是否删除车棚?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loadTable = true;
        agentDelCarport(id)
          .then((res) => {
            this.resFetch({ res });
          })
          .finally(() => {
            this.loadTable = false;
          });
      });
    },
    fetchData() {
      this.loadTable = true;
      this.params.pageNum = this.current;
      this.params.size = this.size;
      agentGetCarportByPage(this.params)
        .then((res) => {
          this.total = res.data.total;
          this.records = res.data.records;
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .wrapper {
    .card {
      height: 80px !important;
      padding-left: 10px !important;
    }
  }

  /deep/ .el-form-item {
    margin-bottom: 10px !important;
  }
}
</style>

<style lang="scss" scoped>
.wrapper {
  padding: 10px;
  background: #fff;
  .card {
    border: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    height: 120px;
    padding-left: 30px;
    margin-bottom: 10px;
    cursor: pointer;

    .img {
      width: 58px;
      height: 58px;
      display: block;
    }

    .card-content {
      margin-left: 10px;

      div:last-child {
        margin-top: 5px;
      }
    }
  }
}
</style>
